import React, { useState } from 'react';

interface CreateWorkspaceDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onCreate: (name: string, icon: string) => void;
}

const EMOJI_OPTIONS = [
  '📁', '📂', '🗂️', '📌', '🎯', '🔧',
  '📖', '🏠', '💡', '🚀', '⭐', '🔬',
  '📐', '🎨', '🏗️', '📋', '🧩', '💻',
];

const CreateWorkspaceDialog: React.FC<CreateWorkspaceDialogProps> = ({
  isOpen,
  onClose,
  onCreate,
}) => {
  const [name, setName] = useState('');
  const [icon, setIcon] = useState('📁');

  if (!isOpen) return null;

  const handleCreate = () => {
    const trimmed = name.trim();
    if (!trimmed) return;
    onCreate(trimmed, icon);
    setName('');
    setIcon('📁');
    onClose();
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && name.trim()) {
      handleCreate();
    }
    if (e.key === 'Escape') {
      onClose();
    }
  };

  return (
    <div className="workspace-dialog-overlay" onClick={onClose} role="presentation">
      <div
        className="workspace-dialog"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="create-ws-title"
      >
        <h3 id="create-ws-title">Create Workspace</h3>

        <div className="workspace-dialog-field">
          <label htmlFor="create-ws-name">Name</label>
          <input
            id="create-ws-name"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="e.g., My Teaching Tools"
            autoFocus
            maxLength={30}
            aria-required="true"
          />
        </div>

        <div className="workspace-dialog-field">
          <label id="create-ws-icon-label">Icon</label>
          <div className="emoji-picker-grid" role="radiogroup" aria-labelledby="create-ws-icon-label">
            {EMOJI_OPTIONS.map((emoji) => (
              <button
                key={emoji}
                className={`emoji-picker-btn ${icon === emoji ? 'selected' : ''}`}
                onClick={() => setIcon(emoji)}
                type="button"
                role="radio"
                aria-checked={icon === emoji}
                aria-label={`Icon ${emoji}`}
              >
                {emoji}
              </button>
            ))}
          </div>
        </div>

        <div className="workspace-dialog-actions">
          <button className="btn-cancel" onClick={onClose}>
            Cancel
          </button>
          <button
            className="btn-primary-ws"
            onClick={handleCreate}
            disabled={!name.trim()}
          >
            Create
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateWorkspaceDialog;
